module.exports = __webpack_public_path__ + "static/img/i-dekirukoto.8aaf1cf.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/3kfan/i-dekirukoto.png
// module id = aK/y
// module chunks = 0